import { CloseOutlined } from '@ant-design/icons';
import { Spin, message, notification } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ArgsProps, NotificationInstance } from 'antd/es/notification/interface';
import { ReactNode } from 'react';
import ParagraphWithTooltip from '../components/ParagraphWithTooltip';

let dynamicMessage: MessageInstance;
let dynamicNotification: NotificationInstance;

export default function useNotificationStore() {
    const [messageApi, dynamicMessageContextHolder] = message.useMessage({ duration: 3 });
    const [notificationApi, dynamicNotificationContextHolder] = notification.useNotification();
    dynamicMessage = messageApi;
    dynamicNotification = notificationApi;
    return { dynamicMessageContextHolder, dynamicNotificationContextHolder };
}
function grispiNotification(
    type: keyof NotificationInstance | 'loading',
    message?: ReactNode,
    key?: React.Key,
    duration = 3
) {
    if (type === 'destroy') {
        return dynamicNotification[type](key);
    }
    const defaultOptions: Omit<ArgsProps, 'message'> = {
        className: 'grispi-notification',
        closeIcon: <CloseOutlined />,
        duration,
        placement: 'top',
        style: {
            maxWidth: '900px',
            padding: '10px 12px 10px 10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    };
    const options: ArgsProps = {
        ...defaultOptions,
        message: <ParagraphWithTooltip message>{message}</ParagraphWithTooltip>,
        key
    };
    if (type === 'loading') {
        return dynamicNotification.open({
            icon: <Spin />,
            ...options
        });
    }
    return dynamicNotification[type](options);
}

export { dynamicMessage, dynamicNotification, grispiNotification };
